import api from '../../plugins/api';

//Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ Ð¿ÐµÑÐµÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ Ð°Ð²ÑÐ¾ Ð² Freedom
const ffinReRegisterConfirm = ({ appealId }) => {
  return api.post('/api/bank/ffin/re-register/confirm', { appealId });
};

export default ffinReRegisterConfirm;
